/**
 * Constants for NCR Edit module
 */

import { StepConfig } from './types';

export const WORKFLOW_STEPS: StepConfig[] = [
  { num: 1, label: 'Created', sublabel: 'NCR raised', role: 'Supplier' },
  { num: 2, label: 'CA Submitted', sublabel: 'Root cause analysis', role: 'Customer' },
  { num: 3, label: 'CAR Submitted', sublabel: 'Corrective action', role: 'Customer' },
  { num: 4, label: 'Closed', sublabel: 'Complete', role: 'Supplier' },
];

export const RCA_REQUIRED_FIELDS = [
  'why_1',
  'why_2',
  'why_3',
  'why_4',
  'why_5',
  'selected_root_cause',
  'immediate_corrective_action',
];

export const CAR_REQUIRED_FIELDS = ['corrective_action', 'preventive_action', 'impact_assessment'];
